
import { defineComponent, PropType, onMounted, ref } from 'vue';
import { Expert } from '@/types';
import IconExpert from "@/components/icons/IconExpert.vue";
import $ from 'jquery';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

export default defineComponent({
  name: 'ExpertsSection',
  components: {
    IconExpert
  },
  props: {
    experts: {
      type: Array as PropType<Expert[]>,
      required: true,
      default: () => []
    }
  },
  setup() {
    const carouselInitialized = ref(false);

    const initCarousel = () => {
      if (carouselInitialized.value) return;

      //@ts-ignore
      $('.experts-carousel').owlCarousel({
        loop: true,
        items: 4,
        nav: true,
        dots: false,
        smartSpeed: 200,
        responsive: {
          0: {
            items: 1,
          },
          540: {
            items: 2,
          },
          768: {
            items: 4,
          },
          1920: {
            items: 6,
          }
        }
      });


      carouselInitialized.value = true;
    };

    const getImageUrl = (pic: string) => {
      return `/pic/experts/${pic}`;
    };

    const handleImageError = (e: Event) => {
      const img = e.target as HTMLImageElement;
      img.src = '/pic/experts/default.png';
    };

    onMounted(() => {
      initCarousel();
    });

    return {
      getImageUrl,
      handleImageError
    };
  }
});
